import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import history from './history';
import './react-table-defaults';
import './styles/index.css';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import {StateProvider} from './main/custom/StateProvider'
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n'

// eslint-disable-next-line
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { routes } from './fuse-configs/fuseRoutesConfig';
import { FuseLayout, FuseTheme, FuseAuthorization } from '@fuse';
import MainToolbar from './main/MainToolbar';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import MainFooter from './main/MainFooter';
import jssExtend from 'jss-extend'
//import QuickPanel from 'main/quickPanel/QuickPanel';
import store from 'store';

import { library } from '@fortawesome/fontawesome-svg-core';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faBars, faSignOutAlt, faUserCircle, faThLarge, faHome, faAddressCard, faTimes, faPiggyBank, faFileAlt, faFileInvoiceDollar, faFileInvoice, faPlusCircle,faMinusCircle} from '@fortawesome/free-solid-svg-icons';

library.add(faCheckCircle, faTimesCircle, faSignOutAlt, faUserCircle, faBars, faThLarge, faHome, faAddressCard, faTimes,faPiggyBank, faFileAlt,faFileInvoiceDollar,faPlusCircle,faMinusCircle, faFileInvoice);

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <StateProvider>
    <Provider store={store}>
      <Router history={history}>
        <FuseAuthorization routes={routes}>
          <FuseTheme>
            <FuseLayout
              routes={routes}
              toolbar={
                <MainToolbar />
              }
              navbarHeader={
                <MainNavbarHeader />
              }
              navbarContent={
                <MainNavbarContent />
              }
              footer={
                <MainFooter />
              }
            />
          </FuseTheme>
        </FuseAuthorization>
      </Router>
    </Provider>
    </StateProvider>
  </JssProvider>
  </I18nextProvider>
  , document.getElementById('root'));

//registerServiceWorker();
